// src/pages/Feedback/FeedbackSuccess.js
import React, { useEffect } from "react";
import "./FeedbackSuccess.css";
import { useNavigate } from "react-router-dom";

const FeedbackSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="feedback-success-container">
      <div className="feedback-success-card">
        <div className="success-tick">
          ✓
        </div>

        <h1 className="success-title">Thank You!</h1>

        <p className="success-text">
          Your responses have been submitted successfully.
          <br />
          A confirmation email has been sent to your mail id shortly. Check it.
        </p>

        <p className="success-note">
          Note: Please check Spam/Junk Folder.
        </p>

        <p className="success-footer-text">
          Our team will reach out to you shortly.
        </p>

        <p className="success-sign">
          - Praveen Kumar With <span className="heart">❤️</span>
        </p>

        <button className="success-btn" onClick={() => navigate("/")}>
          Go Back Home
        </button>

        <p className="auto-redirect">
          Redirecting to Home in <b>10 seconds...</b>
        </p>

        <div className="success-bottom">
          <p>
            © {new Date().getFullYear()} Praveen Kumar B. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSuccess;